import { logFlexDatesPriceVerification } from '@mfs/client/common/log-ga-event/logGaEvent-flex-dates'
import PCLNAnalytics from '@pcln/analytics'
import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays'
import { buildAirportsString } from '../../util/logRetailPriceWithAPGData/logRetailPriceWithAPGData'

export const getIsTravelDateCheapest = ({ flexDates, travelDate, minimumRetailPrice }) => {
  return flexDates
    .filter(
      (record) =>
        record.dates?.[0] &&
        record.dates[0] !== travelDate &&
        record.minimumFare?.amtPerPax &&
        record.minimumFare.amtPerPax > 0
    )
    .every((record) => record.minimumFare && minimumRetailPrice <= record.minimumFare.amtPerPax)
}

export const logResultsToSplunk = ({
  data,
  request,
  tripType,
  minimumRetailPrice,
  searchRequest,
  isTravelDateCheapest,
  isSuperSearch = false,
}) => {
  const { trips, requestId } = request
  const numCheaper = data.filter(
    (date) => date.minimumFare?.amtPerPax && date.minimumFare.amtPerPax < minimumRetailPrice
  ).length
  const numResultsWithoutPrice = data.filter((date) => !date.minimumFare?.amtPerPax).length
  const numResults = data.length

  const lengthOfStay =
    tripType === 'OW'
      ? undefined
      : differenceInCalendarDays(
          new Date(trips[1].departDate || trips[1].departDateRange?.fromDate),
          new Date(trips[0].departDate || trips[0].departDateRange?.fromDate)
        )

  const departDateMonth = new Date(trips[0].departDate || trips[0].departDateRange?.fromDate).getMonth() + 1

  const numSuperSearch = data.filter((date) => Boolean(date.isSuperSearchBotItin)).length

  const numFirefly = data.filter((date) => Boolean(date.isFirefly)).length
  const numExdResults = data.filter((date) => Boolean(date.minimumFare?.isPrivateFare)).length

  const log = {
    action: 'info',
    label: isSuperSearch ? 'FLEX-DATES-SUPERSEARCH-CLICK' : 'FLEX-DATES-RESULTS',
    airports: buildAirportsString(searchRequest),
    tripType,
    minimumRetailPrice,
    searchSlices: searchRequest.slicesURL,
    numResults: numResults.toString(),
    numExdResults: numExdResults.toString(),
    numResultsWithoutPrice: isSuperSearch ? null : numResultsWithoutPrice.toString(),
    numSuperSearch: numSuperSearch.toString(),
    numFirefly: numFirefly.toString(),
    numCheaper: isSuperSearch ? null : numCheaper.toString(),
    isTravelDateCheapest: isSuperSearch ? null : isTravelDateCheapest.toString(),
    requestId,
    LOS: lengthOfStay,
    departDateMonth,
  }

  PCLNAnalytics.log(log)
}

export const logPriceAccuracy = ({
  sliceInfo,
  recommendedListings,
  listings,
  minimumRetailPrice,
  minimumListingPrice,
  error,
  tripType,
}) => {
  /* istanbul ignore else */
  if (window.localStorage) {
    const key = `${sliceInfo.route_city}_${sliceInfo.travelDate}`
    const selectedFlexDateData = JSON.parse(window.localStorage.getItem(key))

    if (selectedFlexDateData) {
      const combinedListings = [...recommendedListings, ...listings].filter(
        (listing) => !listing.isExpressDeal && listing.priceKey
      )
      const validatingCarrierMatch = combinedListings.find((listing) => {
        if (!listing.marketingAirlines?.[0]?.code || !listing.price?.[1]?.amount) {
          return false
        }

        return (
          selectedFlexDateData.validatingCarrier === listing.marketingAirlines[0].code &&
          minimumRetailPrice === listing.price[1].amount
        )
      })
      const actualPriceCarrier = validatingCarrierMatch?.marketingAirlines?.[0]?.code

      const firstCheapestListingCarrier = combinedListings.find((listing) => {
        if (!listing.price?.[1]?.amount) {
          return false
        }

        return listing.price[1].amount === minimumRetailPrice
      })?.marketingAirlines?.[0]?.code

      const isExpressDeal = Boolean(selectedFlexDateData.isExpressDeal)

      PCLNAnalytics.log({
        action: 'info',
        label: 'FLEX-DATES-ACCURACY',
        priceFromCache: selectedFlexDateData.price || 'null',
        priceFromCacheCarrier: selectedFlexDateData.validatingCarrier || 'null',
        actualPrice: minimumRetailPrice,
        actualPriceCarrier: actualPriceCarrier || firstCheapestListingCarrier,
        dealType: isExpressDeal ? 'express_deal' : 'retail',
        priceDiff: selectedFlexDateData.price ? minimumRetailPrice - selectedFlexDateData.price : 'null',
        origin: sliceInfo.originAirport,
        destination: sliceInfo.destinationAirport,
        prevTravelDate: selectedFlexDateData.prevSearchInfo.travelDate,
        prevMinPrice: selectedFlexDateData.prevSearchInfo?.cheapestPrice || 'null',
        dateSelected: selectedFlexDateData.date,
        isSuperSearchBotItin: Boolean(selectedFlexDateData.isSuperSearchBotItin).toString(),
        isSuperSearchItin: Boolean(selectedFlexDateData.isSuperSearchItin).toString(),
      })

      logFlexDatesPriceVerification({ selectedFlexDateData, minimumListingPrice, error, tripType })

      window.localStorage.removeItem(key)
    }
  }
}
